import React from 'react';
import Toggle from 'react-bootstrap-toggle';
import PropTypes from 'prop-types';

function ToggleButton({ value, onToggle }) {
  return (
    <Toggle
      on="on"
      off="off"
      size="sm"
      className="toggle-switch"
      active={value === true}
      onClick={onToggle}
    />
  );
}

ToggleButton.propTypes = {
  value: PropTypes.bool,
  onToggle: PropTypes.func,
};

export default ToggleButton;
